export function showErrorToast(message) {
    // TODO: implement toast message
}

export function showTooManyRequestsError() {
    try {
        clarity("set", "error", "too_many_requests");
    } catch (e) {}
    document.getElementById('limit_error').classList.remove("hidden");
    document.getElementById("subscription_modal").classList.remove("hidden");
    document.getElementById("plans_modal_close")?.classList.add("hidden");
}